module.exports = __webpack_public_path__ + "images/pattern-8a076020e404af76b581410abd7c35f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pattern.png
// module id = cI7N
// module chunks = 0